'use client'
import useResponsive from '@/hooks/useResponsive'

import { EdsnButton } from '@8percent/edsn-react'

/** 구 eds 토큰 text-label / bg-elevated 가 라이트에서 렌더하던 값. */
const SHARE_BG = '#858d94'
const SHARE_COLOR = '#ffffff'

type Props = {
  handleClick: () => void
}

export default function ShareButton(props: Props) {
  const responsive = useResponsive()

  return (
    <EdsnButton
      onClick={props.handleClick}
      // 모바일은 라벨 없이 아이콘온리(정사각) — 구 text="" 동작과 같다.
      label={responsive.isMobile() ? undefined : '공유'}
      aria-label="공유"
      size="l"
      trailingIcon="link"
      // edsn 버튼에는 임의 색 축이 없다. 구 회색 배경(text-label)에 대응하는 시맨틱이 없어
      // 마이그레이션 가이드 "수동 결정 항목" 방침대로 옛 라이트 값을 직접 넣어 시각을 보존한다.
      style={{
        backgroundColor: SHARE_BG,
        color: SHARE_COLOR
      }}
    />
  )
}
